import { useState, useEffect } from "react"
import { useUpdateUserMutation, useDeleteUserMutation } from "./usersApiSlice"
import { useNavigate } from "react-router-dom"
import { ROLES } from "../../config/roles"

const USER_REGEX = /^[A-z]{3,20}$/
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/

const EditUserForm = ({ user }) => {

    const [updateUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateUserMutation()

    const [deleteUser, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteUserMutation()

    const navigate = useNavigate()

    const [username, setUsername] = useState(user.username)
    const [validUsername, setValidUsername] = useState(false)
    const [password, setPassword] = useState('')
    const [validPassword, setValidPassword] = useState(false)
    const [roles, setRoles] = useState(user.roles)
    const [active, setActive] = useState(user.active)

    useEffect(() => {
        setValidUsername(USER_REGEX.test(username))
    }, [username])

    useEffect(() => {
        setValidPassword(PWD_REGEX.test(password))
    }, [password])

    useEffect(() => {
        // console.log(isSuccess)
        if (isSuccess || isDelSuccess) {
            setUsername('')
            setPassword('')
            setRoles([])
            navigate('/dash/users')
        }

    }, [isSuccess, isDelSuccess, navigate])

    const onUsernameChanged = e => setUsername(e.target.value)
    const onPasswordChanged = e => setPassword(e.target.value)

    const onRolesChanged = e => {
        const values = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        )
        setRoles(values)
    }

    const onActiveChanged = () => setActive(prev => !prev)

    const onSaveUserClicked = async (e) => {
        if (password) {
            await updateUser({ id: user.id, username, password, roles, active })
        } else {
            await updateUser({ id: user.id, username, roles, active })
        }
    }

    const onDeleteUserClicked = async () => {
        await deleteUser({ id: user.id })
    }

    const options = Object.values(ROLES).map(role => {
        return (
            <option
                key={role}
                value={role}

            > {role}</option >
        )
    })

    let canSave
    if (password) {
        canSave = [roles.length, validUsername, validPassword].every(Boolean) && !isLoading
    } else {
        canSave = [roles.length, validUsername].every(Boolean) && !isLoading
    }

    // validate roles, username, and password
    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
    const validUserClass = !validUsername ? 'form__input--incomplete' : ''
    const validPwdClass = password && !validPassword ? 'form__input--incomplete' : ''
    const validRolesClass = !Boolean(roles.length) ? 'form__input--incomplete' : ''

    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    const content = (
        <>
            <p className={errClass}>{errContent}</p>
           
            <form className="form" onSubmit={e => e.preventDefault()}>
          <div className="text-center"> 
           {/* EditUser Username */}
               
              <div> 
                <div>
                    <label className="float-left ml-10 md:float-none" htmlFor="username">
                        Username: 
                        {/* <span className="nowrap">[3-20 letters]</span> */}
                    </label>
                </div>

                <div>
                    <input
                        className={`rounded-md w-[20rem]  md:w-[15rem] text-black pl-1 py-1 ${validUserClass}`}
                        id="username"
                        name="username"
                        type="text"
                        autoComplete="off"
                        value={username}
                        onChange={onUsernameChanged}
                    />
                </div>
               </div> 





            {/* EditUser Password  */}
            <div className="pt-[1rem]">
               <div> 
                    <label className="float-left ml-10 md:float-none" htmlFor="password">
                        Password: 
                        {/* <span className="nowrap">[empty = no change]</span> <span className="nowrap">[4-12 chars incl. !@#$%]</span> */}
                    </label>
                </div>

                <div>
                    <input
                        className={`rounded-md w-[20rem]  md:w-[15rem] text-black pl-1 py-1 ${validPwdClass}`}
                        id="password"
                        name="password"
                        type="password"
                        value={password}
                        onChange={onPasswordChanged}
                    />
                </div>
            </div>


            {/* EditUser Status (active/not) */}
                <div className="pt-[1rem]">     
                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                        Status (active/not): &nbsp;&nbsp; 
                        <input
                            className="w-[1.5rem] h-[1.5rem] rounded"
                            id="user-active"
                            name="user-active"
                            type="checkbox"
                            checked={active}
                            onChange={onActiveChanged}
                        />
                    </label>
                </div>
            
            
            
            

            {/* EditUser Assigned Role */}
              
            <div className="pt-[1rem]">
              <div>
                    <label className="form__label" htmlFor="roles">
                        Assigned Role:
                    </label>
              </div>
                 <div>
                    <select
                        id="roles"
                        name="roles"
                        className={`text-black w-[15rem] rounded-md text-center ${validRolesClass}`}
                        multiple={true}
                        size="3"
                        value={roles}
                        onChange={onRolesChanged}
                    >
                        {options}
                    </select>
                 </div>
             </div>



                    {/* EditUser Actions (save/delete) */}
                    
                    <div className="mt-[3rem] md:mt-[16rem] float-right pr-2">
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            title="Save"
                            onClick={onSaveUserClicked}
                            disabled={!canSave}
                        >
                            Save 
                        </button>
                        <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded ml-1"
                            title="Delete"
                            onClick={onDeleteUserClicked}
                        >
                            Delete 
                        </button>
                    </div>
                
            </div>
         </form>
        </>
    )

    return content
}
export default EditUserForm